<template>
  <div class="page">
    <div v-if="!expiredLink" class="innerPage">
      <h1>Cadastre uma nova senha</h1>
      <el-form ref="form" :model="user">
        <el-form-item>
          <el-input
            placeholder="Digite sua nova senha"
            v-model="user.new_password"
            show-password
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-input
            placeholder="Digite sua nova senha novamente"
            v-model="user.new_password_confirmation"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleResetPwd"
            >Alterar senha</el-button
          >
        </el-form-item>

        <el-form-item>
          <div v-if="changePwdSuccess">
            <el-alert type="success" effect="dark">
              Senha alterada com sucesso!
            </el-alert>
          </div>
          <div v-else-if="wrongPwdConfirmation">
            <el-alert type="warning" effect="dark">
              A nova senha e a confirmação da nova senha não são iguais
            </el-alert>
          </div>
          <div v-else-if="changePwdError">
            <el-alert type="error" effect="dark">
              Houve um erro ao redefinir a senha
            </el-alert>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div v-else class="innerPage">
      <div class="recoverLinkExpired">
        O link para redefinir a senha está expirado.
      </div>
    </div>
  </div>
</template>

<script>
import { resetPwdLinkStatus } from "../../../services/user";
import { resetPwd } from "../../../services/user";
export default {
  data() {
    return {
      expiredLink: false,
      user: {
        token: this.$route.params.token,
      },
      changePwdSuccess: false,
      wrongPwdConfirmation: false,
      changePwdError: false,
    };
  },

  methods: {
    handleResetPwd() {
      this.changePwdSuccess = false;
      this.wrongPwdConfirmation = false;
      this.changePwdError = false;
      resetPwd(this.user)
        .then((response) => {
          if (response.status == 200) {
            this.changePwdSuccess = true;
          }
        })
        .catch((error) => {
          console.log("reset password error", error);
          switch (error.response.status) {
            case 422:
              this.wrongPwdConfirmation = true;
              break;
            default:
              this.changePwdError = true;
          }
        });
    },
  },

  created() {
    resetPwdLinkStatus(this.$route.params.token)
      .then((response) => {
        if (response.status == 200) {
          this.expiredLink = false;
        }
      })
      .catch((error) => {
        this.expiredLink = true;
        console.log("password reset link error", error);
      });
  },
};
</script>

<style scoped>
.page {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  background-color: #d3dce6;
  width: 40%;
  margin: auto;
  margin-top: 2%;
  margin-bottom: 2%;
  overflow: overlay;
  position: relative;
  display: flex;
  text-align: center;
}
.innerPage {
  margin: 0 auto;
}
.recoverLinkExpired {
  text-align: center;
  margin: 50px;
  font-size: 25px;
}
</style>
